export default {
  title: 'Prämien & Coupons',
  store_credit: 'Guthaben',
  points_balance: 'Punktestand',
};
